/* src/app/timeline-artic/pages/timeline-artic/timeline-artic.component.scss */
.unitHeader {
  border-bottom: 1px dashed #000;
}
h4 {
  border-bottom: 2px solid black;
}
.jobBlock {
  border: 1px solid black;
}
.jobBlock .jobBlockTop {
  border-bottom: 2px dashed black;
}
.jobBlock .jobBlockTop span {
  font-weight: bold;
}
.jobBlock .infoBlock {
  border-bottom: 1px dashed black;
}
.jobBlock .infoBlock span {
  font-weight: bold;
}
.whiteBg {
  background: RGBA(255, 255, 255, 0.7);
}
.whiteBg h4 {
  cursor: pointer;
}
.whiteBg .anim-collapse {
  transition: all 300ms ease-in;
}
.jobBg {
  border: 1px solid gray;
  background: RGBA(200, 200, 200, 0.4);
}
.driverBlock {
  text-align: center;
  font-weight: bold;
  background: RGBA(200, 200, 200, 0.8);
  cursor: pointer;
  border-radius: 15px;
  border: 2px solid black;
}
.subbieBlock {
  text-align: center;
  font-weight: bold;
  background: RGBA(50, 50, 50, 0.8);
  color: #fff;
  cursor: pointer;
  border-radius: 15px;
  border: 2px solid black;
}
.unavailableBlock {
  text-align: center;
  font-weight: bold;
  background: RGBA(180, 0, 0, 0.4);
  color: #000;
  border: 2px dashed red;
  border-radius: 15px;
}
.unavailableBlock span {
  font-weight: bold;
}
.dropZone {
  pointer-events: none;
  text-align: center;
  font-weight: bold;
  background: #cebd95;
}
.orderBlock {
  text-align: center;
  font-weight: bold;
  background: RGBA(200, 200, 200, 0.8);
  cursor: pointer;
  border-radius: 15px;
  border: 2px solid black;
}
.orderBlock span {
  font-size: 10px;
}
.timelineBlock {
  pointer-events: none;
  text-align: center;
  font-weight: bold;
  background: #cebd95;
}
.timeBlock {
  text-align: center;
  font-weight: bold;
  background: RGBA(200, 200, 200, 0.8);
  border-radius: 15px;
  border: 2px solid black;
}
.emptyBlock {
  pointer-events: none;
}
.emptyBlock span {
  pointer-events: none;
}
.emptyBlock {
  border: 1px dotted #000;
  border-radius: 15px;
}
.emptyTimeBlock {
  border: 1px dotted #000;
  border-radius: 15px;
  width: 150px;
  padding: 0;
  margin: 0;
}
.incompleteRoute {
  border: 2px solid red;
}
.completeRoute {
  border: 2px solid green;
}
.collapsedJobBlock {
  border: 1px solid black;
  font-size: 10px;
}
.collapsedJobBlockPending {
  background: RGBA(0, 0, 0, 0.4);
  color: #fff;
}
.collapsedJobBlockSent {
  background: RGBA(0, 180, 0, 0.4);
  color: #000;
}
.collapsedJobBlockDeleted {
  background: RGBA(180, 0, 0, 0.4);
  color: #000;
}
.collapsedJobBlockSigned {
  background: RGBA(0, 0, 180, 0.4);
  color: #fff;
}
.iconBlock {
  color: #000;
  text-align: right;
}
.iconBlock i:hover {
  cursor: pointer;
}
.datePicker {
  display: inline-block;
  position: absolute;
  left: 30rem;
  top: 3rem;
}
.timelineToolbarContainer {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
}
.dateSelectorContainer {
  display: flex;
  flex-flow: row wrap;
  text-align: center;
}
.dateSelectorContainer i:hover {
  cursor: pointer;
}
.dateSelectorContainer .dateSelectorBox {
  background-color: RGBA(255, 255, 255, 0.6);
  width: 70%;
  font-size: 1.2rem;
  text-align: center;
  color: #34495e;
  font-weight: bold;
}
.dateSelectorContainer .dateSelectorBox:hover {
  color: #2196f3;
  cursor: pointer;
}
.qtyBox {
  text-align: center;
  font-weight: bold;
  border-left: 1px dashed black;
}
.jobDetails span {
  font-weight: bold;
}
.routeName {
  font-size: 12px;
  font-weight: bold;
}
.pink {
  background: pink;
}
/*# sourceMappingURL=timeline-artic.component.css.map */
